const BASE = '/api/v1/intelligence-v2'

// ⚠️ [#4 do review do PR #2342] TODO valor dinâmico interpolado numa URL passa
// por `encodeURIComponent`, sem exceção. A regra já é do repo ("`encodeURIComponent`
// em todo valor dinâmico de query string", CLAUDE.md § Frontend Security) e
// valia aqui só onde alguém lembrou (`rascunhoEntrega`): os 38 ids restantes
// iam crus. Um id com `/`, `?` ou `#` muda a ROTA que o servidor lê, e o que
// chega em `:idConversa` vem da URL — ou seja, de fora. Encodar um UUID não
// muda um byte; é o caso que NÃO é UUID que a linha existe para pegar.

export const intelligenceV2 = {
  chat: `${BASE}/chat`,
  // Canal de ANÁLISE (spec-009-anexo-sem-trava, [T008]) — sobe anexo sem
  // exigir cliente resolvido. `contracts/anexo-analise.md` §1.
  anexosAnalise: `${BASE}/anexos-analise`,
  // Vincular DEPOIS um anexo de análise a um cliente (`contracts/anexo-
  // analise.md` §2, spec-009 T013). Função porque o `upload_id` é parte do
  // caminho — e `encodeURIComponent` porque ele é OPACO: o formato de hoje
  // (`analise:<uuid>`) tem `:`, e o de amanhã é problema do servidor, não
  // desta linha.
  anexoAnaliseCliente: (uploadId) =>
    `${BASE}/anexos-analise/${encodeURIComponent(uploadId)}/cliente`,
  // Catálogo de atalhos do `/` (spec-013): prefixo do módulo ia-crm, não o `BASE`.
  atalhos: '/v2/api/ia-crm/atalhos',
  // ★ [spec-010 T030] Até aqui existiam DUAS rotas DEDICADAS —
  // `chatConsultorEstrategico` (`/consultor-estrategico/chat`) e `chatFeeFixo`
  // (`/fee-fixo/chat`) — que fixavam persona e origem pelo próprio endpoint.
  // A spec-010 (D6/ADR-30, US-7) as aposenta: o Supervisor decide o agente a
  // partir do turno, e o que cada superfície declara é só `origem_modulo` no
  // corpo do `chat` acima (`consultor-painel.vue`, `view-consultor-
  // estrategico.vue`, `apiFeeFixoIa.js`). As rotas dedicadas no BACKEND
  // continuam registradas até o `resource_chat_consultor.py`/
  // `resource_chat_fee_fixo.py` serem removidos ([T032], onda A release 2,
  // atrás do gate A1 em homolog) — o front simplesmente não fala mais com
  // elas.
  // Rota DEDICADA do Especialista em Comissionamento (F3 do porte do agente).
  // Persona e origem vêm do ENDPOINT, não do corpo — num endpoint dedicado,
  // aceitar `persona` no body deixaria o cliente falar com outro agente por uma
  // porta que não é dele. É também onde o backend pendura o gate da flag
  // `IA - Comissões`. Diferente das duas rotas aposentadas acima, esta NÃO
  // passa pelo Supervisor: `comissoes` não tem linha em `_agentes` e é resolvida
  // por `_transicao_legada` — a rota dedicada continua sendo o caminho real.
  //
  // O backend registra só o POST: status, reconnect e cancel seguem nas rotas
  // genéricas abaixo, que são do MOTOR e valem para qualquer superfície.
  chatComissoes: `${BASE}/comissoes/chat`,
  chatStatus: (id) => `${BASE}/chat/${encodeURIComponent(id)}/status`,
  chatReconnect: (id) => `${BASE}/chat/${encodeURIComponent(id)}/reconnect`,
  chatCancel: (id) => `${BASE}/chat/${encodeURIComponent(id)}/cancel`,
  conversations: `${BASE}/conversations`,
  conversation: (id) => `${BASE}/conversations/${encodeURIComponent(id)}`,
  folders: `${BASE}/folders`,
  folder: (id) => `${BASE}/folders/${encodeURIComponent(id)}`,
  conversationMessages: (id) => `${BASE}/conversations/${encodeURIComponent(id)}/messages`,
  feedback: (id) => `${BASE}/conversations/${encodeURIComponent(id)}/feedback`,
  // Entregas de arquivo de uma conversa do Modo Agente (spec-008 p11, T026).
  // A listagem devolve o METADADO (`{id_objeto, nome, content_type, bytes,
  // sha256, entregue_em, id_run}`); o download devolve o envelope base64 da
  // casa (`FileHandler.send_file_to_front_base_64()` → `{base64, name,
  // extension}`), lido por `downloadBase64` — nunca `responseType: 'blob'`.
  // ⚠️ A rota INTERNA de objetos (`resource_interno_objetos.py`) usa credencial
  // do worker e NÃO pode ser chamada pelo navegador: estas duas são as públicas.
  // ★ [21/09/2026] `conversas`, em PORTUGUES. Nasceram em ingles e davam 404 — o owner
  // abriu o DevTools com `GET .../conversations/<id>/artefatos -> 404 NOT FOUND`, e a
  // secao "Entregas" nunca carregava: a resposta anunciava o arquivo e ele nao saia.
  // Medido contra o backend, autenticado, na conversa da tela dele:
  //     /conversations/<id>/artefatos -> 404   ·   /conversas/<id>/artefatos -> 200
  //
  // ⚠️ O aviso ja' estava escrito 60 linhas abaixo, em `conversaArtefatos`: "nao ha um
  // prefixo so', e trocar o idioma aqui da' 404". Este par nasceu ignorando-o. Sao DUAS
  // familias para a mesma rota — `apiArtefatos.js` usa esta, `apiArtefatosConversa.js`
  // usa a de baixo; unificar e' trabalho a' parte, mas as quatro tem de falar PT.
  artefatosDaConversa: (idConversa) =>
    `${BASE}/conversas/${encodeURIComponent(idConversa)}/artefatos`,
  artefatoDaConversa: (idConversa, idObjeto) =>
    `${BASE}/conversas/${encodeURIComponent(idConversa)}/artefatos/${encodeURIComponent(idObjeto)}`,
  promptSuggestions: `${BASE}/prompt-suggestions`,
  // Texto de uma pergunta pré-definida (o prompt vive no backend; aqui só a chave).
  perguntaPredefinida: (chave) => `${BASE}/perguntas-predefinidas/${chave}`,
  supportedModels: `${BASE}/supported-models`,
  apiKeys: `${BASE}/api-keys`,
  apiKey: (id) => `${BASE}/api-keys/${encodeURIComponent(id)}`,
  // Vínculo do WhatsApp do profissional (GET estado / POST gerar código /
  // DELETE revogar). Inbound-first: nada é enviado pelo POST — o profissional
  // manda o código ao número da IA e o webhook ativa.
  whatsappVinculo: `${BASE}/whatsapp/vinculo`,
  whatsappEnviarPdf: `${BASE}/whatsapp/enviar-pdf/`, // + <id_cliente_app>
  whatsappOnboarding: `${BASE}/whatsapp/onboarding`,
  // Rascunho do desenho de entrega de um serviço, em .docx. O código vem do
  // cartão que o Consultor produziu (`citar_servicos`), mas é texto e leva
  // `encodeURIComponent` — `TEC-G3` e `9.1` são inofensivos, o próximo pode não ser.
  rascunhoEntrega: (codigo, idConversa) =>
    `${BASE}/servicos/${encodeURIComponent(codigo)}/rascunho-entrega` +
    (idConversa ? `?id_conversa=${encodeURIComponent(idConversa)}` : ''),
  claudeCodeBundle: `${BASE}/claude-code-bundle`,
  claudeCodeGuide: `${BASE}/claude-code-guide`,

  // Curadoria de sugestões de IA (spec-003) — endpoints da spec-001.
  suggestions: `${BASE}/suggestions`,
  suggestionRestore: (id) => `${BASE}/suggestions/${encodeURIComponent(id)}/restore`,
  suggestionsGrouped: `${BASE}/suggestions/grouped`,
  suggestionsSummary: `${BASE}/suggestions/summary`,
  suggestion: (id) => `${BASE}/suggestions/${encodeURIComponent(id)}`,
  suggestionAccept: (id) => `${BASE}/suggestions/${encodeURIComponent(id)}/accept`,
  suggestionDecline: (id) => `${BASE}/suggestions/${encodeURIComponent(id)}/decline`,
  suggestionsAcceptBatch: `${BASE}/suggestions/accept-batch`,
  suggestionsAcceptAll: `${BASE}/suggestions/accept-all`,

  // Modo Agente (spec-002-chat-agentico-estilo-claude-code) — contracts/api.yaml.
  // Rotas do FRONT (sessão autenticada), sempre HTTP 200 com {status, message, value}.
  // ★ [ponte "a tela escolhe o agente", owner 16/09/2026 — backend PR #1787]
  // Os especialistas que ESTE profissional pode escolher para o run
  // (`agentes/catalogo/*.yaml` com `roteavel: true`, ∩ RBAC da sessão).
  // Lista de servidor, nunca do front: são 17 roteáveis hoje, 3 só-gestor e 3
  // atrás de funcionalidade contratada — o que cada escritório vê varia.
  agentes: `${BASE}/agentes`,
  runs: `${BASE}/runs`,
  runEventos: (idRun, desde) => {
    const query = (desde === undefined || desde === null) ? '' : `?desde=${encodeURIComponent(desde)}`
    return `${BASE}/runs/${encodeURIComponent(idRun)}/eventos${query}`
  },
  runDecisao: (idRun, idProposta) => `${BASE}/runs/${encodeURIComponent(idRun)}/propostas/${encodeURIComponent(idProposta)}/decisao`,
  runCancelar: (idRun) => `${BASE}/runs/${encodeURIComponent(idRun)}/cancelar`,
  run: (idRun) => `${BASE}/runs/${encodeURIComponent(idRun)}`,
  runRetry: (idRun) => `${BASE}/runs/${encodeURIComponent(idRun)}/retry`,
  conversaRunAtual: (idConversa) => `${BASE}/conversas/${encodeURIComponent(idConversa)}/run-atual`,

  // ★ [E-64/E-72] Os ARQUIVOS que o agente entregou na conversa — a porta
  // pública (sessão do profissional) de `core/artefatos_autorizacao.py`. A
  // primeira LISTA (só o que tem recibo de entrega: `tipo` ∈ {`anexo`,
  // `artefato`}, nunca o `manifesto` interno do workspace); a segunda BAIXA
  // um deles, no envelope `FileHandler.send_file_to_front_base_64` — o
  // mesmo `{base64, name, extension}` que `downloadBase64()` consome.
  //
  // ⚠️ `conversas` em PT-BR, como `conversaRunAtual` acima: estas rotas são
  // do Modo Agente, e o backend as registrou nesse prefixo. As rotas de
  // chat clássico (`conversations/...`) continuam em inglês — não há um
  // prefixo só, e trocar o idioma aqui dá 404.
  conversaArtefatos: (idConversa) => `${BASE}/conversas/${idConversa}/artefatos`,
  conversaArtefato: (idConversa, idObjeto) =>
    `${BASE}/conversas/${idConversa}/artefatos/${idObjeto}`,

  // Painel de situação do escritório (os cards da lateral imersiva). Devolve só
  // os NÚMEROS; quais cards existem, com que forma e em que ordem é o catálogo
  // do front (`views/chat-imersivo/insights.js`). Contrato completo em
  // `api/apiInsights.js`.
  insights: `${BASE}/insights`,
  // Preferência do painel personalizável (ordem + visibilidade dos cards),
  // POR PROFISSIONAL — GET (ler; `value: null` = nunca salvou), PUT
  // (`{visiveis}`) e DELETE (restaurar padrão). Contrato em
  // `api/apiPainelPreferencia.js`.
  painelPreferencia: `${BASE}/painel/preferencia`,

  // Memória curada, perfil do profissional, memória de cliente e do
  // escritório (spec-002-memoria-curada-e-perfil-do-profissional, [T016]).
  // `memoriaEscritorio` serve GET (leitura) e POST (gravar combinado) — mesmo
  // padrão de `apiKeys` em `apiApiKeys.js` (uma constante, dois verbos).
  memoria: `${BASE}/memoria`,
  memoriaPerfil: `${BASE}/memoria/perfil`,
  memoriaItem: (id) => `${BASE}/memoria/${encodeURIComponent(id)}`,
  memoriaAuditoria: `${BASE}/memoria/auditoria`,
  memoriaDesfazer: (id) => `${BASE}/memoria/auditoria/${encodeURIComponent(id)}/desfazer`,
  memoriaExport: `${BASE}/memoria/export`,
  memoriaPurge: `${BASE}/memoria/purge`,
  memoriaCliente: (id) => `${BASE}/memoria/clientes/${encodeURIComponent(id)}`,
  memoriaClientePurge: (id) => `${BASE}/memoria/clientes/${encodeURIComponent(id)}/purge`,
  memoriaEscritorio: `${BASE}/memoria/escritorio`,
  memoriaEscritorioPurge: `${BASE}/memoria/escritorio/purge`,

  // Aprovação de skills por risco (spec-007-aprovacao-de-skills-por-risco,
  // [T021]). Timeline "O que a IA aprendeu" (US-5/US-8) + gestão de skills
  // (US-6) + fila única de ações (US-9). Rotas reais confirmadas contra
  // `aawz_intelligence_v2/routes.py` (commit e1b097e45):
  // `resources/resource_aprendizado.py`, `resource_skills_gestao.py`,
  // `resource_acoes_pendentes.py`. `contracts/ui-components.md` §10 é o
  // contrato — mesmos nomes, mesmos paths que os devs paralelos de T022/
  // T023/T042 já usavam (chegaram aditivamente antes de T021 fechar).
  aprendizado: `${BASE}/aprendizado`,
  aprendizadoMetricas: `${BASE}/aprendizado/metricas`,
  aprendizadoItem: (id) => `${BASE}/aprendizado/${encodeURIComponent(id)}`,
  aprendizadoPreview: (id) => `${BASE}/aprendizado/${encodeURIComponent(id)}/preview`,
  aprendizadoDecidir: (id) => `${BASE}/aprendizado/${encodeURIComponent(id)}/decidir`,
  aprendizadoReverter: (id) => `${BASE}/aprendizado/${encodeURIComponent(id)}/reverter`,
  aprendizadoEditar: (id) => `${BASE}/aprendizado/${encodeURIComponent(id)}/editar`,

  skillsGestao: `${BASE}/skills`,
  skillGestao: (id) => `${BASE}/skills/${encodeURIComponent(id)}`,
  skillLifecycle: (id) => `${BASE}/skills/${encodeURIComponent(id)}/lifecycle`,
  skillRestaurar: (id) => `${BASE}/skills/${encodeURIComponent(id)}/restaurar`,

  acoesPendentes: `${BASE}/acoes-pendentes`,

  // Conhecimento oficial (spec-013-knowledge-por-escritorio-e-promocao-de-
  // decisao, [T007]). Os 9 tipos estruturados que o escritório mantém
  // (definição de métrica, política contábil, calendário fiscal etc.) —
  // consultáveis por (knowledge_type, code) sem LLM. `knowledgeItems` serve
  // GET (lista) e `knowledgePromoverPreview`/`knowledgePromover` são o
  // two-step de promoção (preview sem efeito, promover com `confirmar: true`).
  knowledgeTipos: `${BASE}/knowledge/tipos`,
  knowledgeItems: `${BASE}/knowledge/items`,
  knowledgeItem: (id) => `${BASE}/knowledge/items/${encodeURIComponent(id)}`,
  knowledgePromoverPreview: `${BASE}/knowledge/promover/preview`,
  knowledgePromover: `${BASE}/knowledge/promover`,
  // (r3, [T030]) Pendências de promoção (UC-8) — o que a 005 sugeriu como fato
  // novo, ou marcou em conflito com um item vigente, aguardando decisão do
  // gestor. `knowledgePendencias` serve GET (lista) e
  // `knowledgePendenciaDescartar(id)` é o POST de descarte
  // (`ApprovalEngine.decidir(..., 'recusar', ...)` por baixo — nunca
  // 'rejeitado').
  knowledgePendencias: `${BASE}/knowledge/pendencias`,
  knowledgePendenciaDescartar: (id) => `${BASE}/knowledge/pendencias/${encodeURIComponent(id)}/descartar`,

  // Métricas da IA — avaliação e o gate único de publicação (spec-012-
  // avaliacao-e-metricas-de-aprendizado, [T027], `contracts/api.yaml` +
  // `contracts/ui-components.md` §7). Rotas reais confirmadas contra
  // `aawz_intelligence_v2/resources/resource_evals_painel.py` e
  // `resource_evals_resultados.py` (5 rotas, gestor-only, tenant do
  // contexto — nenhuma aceita `id_escritorio` no corpo/query). `periodo`
  // tem default `'30d'` NO BACKEND (`resource_evals_painel.py:35`); o
  // default aqui é só conveniência de chamada, não duplica a regra.
  // `evalsDatasets`/`evalsResultados` levam querystring PRONTA
  // (`formatQueryParams`, montada em `apiMetricasIa.js`) — mesmo padrão de
  // `skillsGestao`/`aprendizado` acima.
  // `encodeURIComponent`: valor dinâmico em query nunca vai cru (CLAUDE.md raiz).
  evalsPainel: (periodo = '30d') =>
    `${BASE}/evals/painel?periodo=${encodeURIComponent(periodo)}`,
  evalsDatasets: (qs = '') => `${BASE}/evals/datasets${qs}`,
  evalsResultados: (qs = '') => `${BASE}/evals/resultados${qs}`,
  evalsResultado: (id) => `${BASE}/evals/resultados/${encodeURIComponent(id)}`,
  evalsExecutar: `${BASE}/evals/executar`,

  // Advisory Hub — engagements persistentes do comitê (spec-011-advisory-
  // engagements-do-comite, US-9, [T062], `contracts/api.yaml`). Rotas reais
  // confirmadas contra `aawz_intelligence_v2/resources/resource_advisory.py`
  // (commit ef07cfcba): 4 rotas, gestor-only, tenant do contexto — nenhuma
  // aceita `id_escritorio` no corpo/query. `advisoryEngagements(qs)` leva
  // querystring PRONTA (`formatQueryParams`), mesmo padrão de `evalsDatasets`.
  advisoryEngagements: (qs = '') => `${BASE}/advisory/engagements${qs}`,
  advisoryEngagement: (id) => `${BASE}/advisory/engagements/${encodeURIComponent(id)}`,
  advisoryEngagementEvents: (id) => `${BASE}/advisory/engagements/${encodeURIComponent(id)}/events`,
  advisoryEngagementDecisao: (id) => `${BASE}/advisory/engagements/${encodeURIComponent(id)}/decisao`,
  // Entrada/saída de voz do composer (v1, por turnos — spec de voz do chat).
  // Áudio é descartado depois da transcrição/síntese; nada persiste além do
  // texto. Ver `api/apiVoz.js`.
  vozTranscrever: `${BASE}/voz/transcrever`,
  vozSintetizar: `${BASE}/voz/sintetizar`,
  // Catálogo curado de vozes (spec-016, [US-2]/[US-3]) — a lista, o default e
  // a frase de amostra vêm SEMPRE do servidor (o front não tem constante
  // própria). `vozAmostra` sintetiza a FRASE FIXA do catálogo numa voz — não
  // aceita texto (ver docstring de `resource_voz.py::ResourceIaCrmVozAmostra`).
  vozCatalogo: `${BASE}/voz/vozes`,
  vozAmostra: `${BASE}/voz/vozes/amostra`,
  // Sessão de voz em TEMPO REAL (spec-008, [T012]/[T023]) — protocolo
  // DISTINTO das quatro rotas acima: aqui não trafega áudio nenhum. O
  // navegador manda o `sdp_offer` que gerou, o servidor cria a sessão no
  // provedor e devolve o `sdp_answer`; a mídia corre navegador↔provedor por
  // WebRTC depois disso. Espelho de `resource_voz_tempo_real.py` (registradas
  // em `aawz_intelligence_v2/routes.py:206-210`).
  //
  // ★ Nenhuma credencial chega ao navegador (invariante N1, `api.yaml` v2):
  // o `sdp_answer` é texto de negociação de mídia, não token.
  vozSessaoTempoReal: `${BASE}/voz/sessao-tempo-real`,
  vozSessaoTempoRealEncerrar: (idSessao) =>
    `${BASE}/voz/sessao-tempo-real/${encodeURIComponent(idSessao)}/encerrar`,

  // AVATAR AO VIVO do primeiro contato (spec-009) — LiveAvatar LITE.
  //
  // ⚠️ NÃO é o Modo de Voz. O Modo de Voz é o GPT-Live, logo acima, e não
  // passa por estas duas rotas. São duas portas separadas por decisão do
  // owner (18/09/2026): o avatar atende o PRIMEIRO contato, o GPT-Live
  // atende todo o resto.
  //
  // O servidor abre a sessão e devolve o que o navegador precisa para
  // FALAR (`ws_url`, o canal de comando) e para VER (`livekit_url` +
  // `livekit_client_token`). A chave do provedor, o `session_token` e o
  // token de AGENTE da sala ficam no servidor — espelho de
  // `resource_avatar_ao_vivo.py` (registradas em `routes.py:222-226`).
  avatarAoVivo: `${BASE}/voz/avatar-ao-vivo`,
  avatarAoVivoEncerrar: (idSessao) =>
    `${BASE}/voz/avatar-ao-vivo/${encodeURIComponent(idSessao)}/encerrar`,
}

/**
 * Catálogo de atalhos de negócio do menu `/` — spec-001
 * (`project-home-ia-skills/preparacao-reuniao`, [T015], `contracts/api.md` §1).
 *
 * Blueprint PRÓPRIO no backend (`IA_CRM_PREFIX = '/v2/api/ia-crm'`,
 * `aawz_intelligence_v2/routes.py`), DIFERENTE do `BASE` acima
 * (`/api/v1/intelligence-v2`, o prefixo INTERNO do módulo) — mesmo padrão
 * `/v2/api/<modulo>` das demais APIs públicas (`/v2/api/office`,
 * `/v2/api/client`, ...). Por isso uma constante separada, e não mais uma
 * chave de `intelligenceV2`.
 */
export const iaCrm = {
  atalhos: '/v2/api/ia-crm/atalhos',
}

/**
 * Canal de transcrição por anexo de TEXTO no composer
 * (spec-010-r2-guiada-pelo-agente-com-transcricao, [T006], US-4).
 *
 * Backend de OUTRO módulo (`aawz_transcriptions`, não `aawz_intelligence_v2`)
 * — prefixo PRÓPRIO, sem reusar o `BASE` deste arquivo. Espelho de
 * `aawz_transcriptions/routes/routes.py::URL_AAWZ_TRANSCRIPTIONS_PREFIX`
 * (`/v3/api/aawz-transcriptions`) + a rota registrada em
 * `routes/transcriptions.py` (`/transcriptions/upload-texto`).
 */
export const aawzTranscriptions = {
  uploadTexto: '/v3/api/aawz-transcriptions/transcriptions/upload-texto',
}

/**
 * A BOAS-VINDAS do primeiro contato (spec-009 [US-2]).
 *
 * `GET`  → `{ deve_entregar, motivo, versao_roteiro, entregue_em, canal }`
 * `POST` → `{ canal: 'audio' | 'texto' }` e devolve
 *          `{ versao_roteiro, canal, entregue_em, ja_entregue }`
 *
 * ★ QUEM DECIDE SE É O PRIMEIRO CONTATO É O SERVIDOR, não o front. A régua (não ter
 * marca E não ter conversa anterior) mora lá porque a checagem não é atômica: quem
 * impede a entrega dupla é a unique do banco, e nenhuma verificação no cliente
 * substitui isso.
 */
export const boasVindas = `${BASE}/boas-vindas`

/**
 * @method GET
 * O CLIPE de fundo do avatar da boas-vindas (spec-009 [US-2]) — devolve
 * `{ status, url, expira_em }` com o `RenderStatus` do vendor
 * (`queued | processing | ready | failed | cancelled`).
 *
 * ★ QUEM GERA É O BACKEND, e não há alternativa: a autenticação do vendor é a
 * chave do projeto, e o contrato dele manda em `securitySchemes` — *"Never
 * expose a project API key in browser code"*. O front só PEDE o clipe já
 * gerado; a chave nunca chega ao browser.
 *
 * ⚠️ A geração é PAGA (créditos do vendor) e leva minutos. Ninguém espera por
 * ela: `url: null` com `queued`/`processing` é resposta normal, e a tela segue
 * com o retrato ou com o selo.
 */
export const boasVindasClipe = `${BASE}/boas-vindas/clipe`

export const iaChangelog = {
  /**
   * @method GET
   * Lista read-only das alteracoes feitas pela IA (US-8), escopado por
   * id_escritorio/permissao no backend. Filtros opcionais: origem, entidade,
   * id_cliente, data_inicio, data_fim, limit, offset.
   */
  list: `${BASE}/ia-changelog`,
}
